import { debounceTime } from 'rxjs/operators';
import { Observable, fromEvent } from 'rxjs';

import { Directive, OnInit, ElementRef, Output, EventEmitter } from '@angular/core';

@Directive({
  selector: '[lSizeevent]'
})
export class SizeeventDirective implements OnInit {

  @Output('lSizeevent')
  public resize: EventEmitter<any> = new EventEmitter();

  constructor(private _ele: ElementRef) { }

  ngOnInit(): void {
    fromEvent(window, 'resize').pipe(debounceTime(500)).subscribe(res => {
      const width: number = this._ele.nativeElement.offsetWidth;
      const height: number = this._ele.nativeElement.offsetHeight;
      this.resize.emit({ width, height });
    });
  }

}
